import React from 'react';

import {
  ReferentielSearchResultDtoVideoTutorielDto,
  UserDtoProfileEnum,
  VideoTutorielDto,
} from 'lib_api/lib/api/gen';

import TableWithoutPaginationAndSort from 'components/WrappedComponents/Table/TableWithoutPaginationAndSort';
import {
  ColumnProps,
  FetchDataResult,
} from 'components/WrappedComponents/Table/types';
import { userMapping } from 'utils/enumData';

import { useReferentielDashboardUnpagedSearch } from '../utils';

import VideoLink from './Composants/VideoLink';
import VideoTitle from './Composants/VideoTitle/VideoTitle';
import DashboardHeader from './DashboardHeader/DashboardHeader';
import { FilterDashboardVideoTutoriel } from './utils/type';
import { useSearchVideoTutoriel } from './utils/useSearchVideoTutoriel';
import CellDetailsAndActions from './CellDetailsAndActions';

function buildDetailsContent(
  data: VideoTutorielDto,
  refreshDashboard: () => void,
): React.ReactElement {
  return (
    <CellDetailsAndActions video={data} refreshDashboard={refreshDashboard} />
  );
}

const DashboardVideos: React.FC = () => {
  const { fetchData, filter, setFilter, refreshDashboard } =
    useReferentielDashboardUnpagedSearch<
      VideoTutorielDto,
      FilterDashboardVideoTutoriel,
      ReferentielSearchResultDtoVideoTutorielDto
    >(useSearchVideoTutoriel, { valid: true });

  function buildColumns(): ColumnProps<VideoTutorielDto>[] {
    return [
      {
        title: 'Profil',
        key: 'profile',
        buildCellContent: video =>
          userMapping[UserDtoProfileEnum[video.profile]],
      },
      {
        title: 'Titre',
        key: 'videoId',
        buildCellContent: video => <VideoTitle videoId={video.videoId} />,
      },
      {
        title: 'URL',
        key: 'url',
        buildCellContent: video => <VideoLink videoId={video.videoId} />,
      },
      {
        title: '',
        buildCellContent: data => buildDetailsContent(data, refreshDashboard),
      },
    ];
  }

  function renderDashboardHeader(
    fetchedData?: FetchDataResult<VideoTutorielDto>,
  ) {
    return (
      <DashboardHeader
        totalCount={fetchedData?.total || 0}
        refreshDashboard={refreshDashboard}
        filter={filter}
        setFilter={setFilter}
      />
    );
  }

  return (
    <div className="table-container">
      <TableWithoutPaginationAndSort
        columns={buildColumns()}
        filter={filter}
        setFilter={setFilter}
        fetchData={fetchData}
        header={renderDashboardHeader}
        canSelectItems={false}
        buildItemKey={(item): string => item.id}
      />
    </div>
  );
};

export default DashboardVideos;
